<template>
  <v-row
    justify="start"
    align="center"
    class="ma-0"
  >
    <v-col
      cols="12"
      sm="12"
      md="8"
      lg="8"
      xl="8"
    >
      <v-flex
        class="d-flex flex-column"
      >
        <span class="body-1">{{item["str_name"]}}</span>
        <span class="caption">{{item["str_description"]}}</span>
      </v-flex>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="4"
      lg="4"
      xl="4"
    >
      <v-flex
        class="d-flex flex-column"
      >
        <v-flex class="d-flex" v-if="chargeTypeIsCredits">
          <span class="body-2 font-weight-bold">Preço Total:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold">{{currencySymbol}} {{item["fl_total_price"] | toFixedWithComma}}</span>
        </v-flex>
        <v-flex class="d-flex" v-if="!chargeTypeIsCredits">
          <span class="body-2 font-weight-bold">Total Hectares:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold"> {{ data_package["total_hectares"] | toFixedWithComma}}</span>
        </v-flex>        
        <v-flex
          v-if="mustShowCreditsDiscount"
          class="d-flex"
        >
          <span class="body-2 font-weight-bold grey--text">Créditos:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold grey--text">{{currencySymbol}} {{item["fl_credits_discount"] | toFixedWithComma}}</span>
        </v-flex>
        <v-flex
          v-if="mustShowCouponDiscount"
          class="d-flex"
        >
          <span class="body-2 font-weight-bold grey--text">Cupom:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold grey--text">{{currencySymbol}} {{item["fl_coupon_discount"] | toFixedWithComma}}</span>
        </v-flex>
        <v-flex
          v-if="mustShowPromotionDiscount"
          class="d-flex"
        >
          <span class="body-2 font-weight-bold grey--text">{{item["promotion"]["nm_promotion"]}}:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold grey--text">{{currencySymbol}} {{item["fl_promotion_discount"] | toFixedWithComma}}</span>
        </v-flex>
        <v-flex class="d-flex" v-if="chargeTypeIsCredits">
          <span class="body-2 font-weight-bold blue--text">Preço final:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold blue--text">{{currencySymbol}} {{item["fl_final_price"] | toFixedWithComma}}</span>
        </v-flex>
        <v-flex class="d-flex" v-if="!chargeTypeIsCredits">
          <span class="body-2 font-weight-bold blue--text">Tipo de pacote:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold blue--text">{{ data_package["type_package"] }}</span>
        </v-flex>        
      </v-flex>
    </v-col>
  </v-row>
</template>

<script>
  import {isEqual} from "lodash/lang"
  import {
    getDataPackageHectareCart
  } from "../../../api/api-billing"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"  

  export default {
    name: "CartItem",
    data: () => ({
      data_package: {
        "type_package": "",
        "total_package": 0
      }
    }),
    props: {
      item: {
        type: Object,
        required: true
      }    
    },
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },           
      mustShowCreditsDiscount() {
        if (!this.item["fl_credits_discount"]) return false
        return !isEqual(this.item["fl_credits_discount"], 0)
      },
      mustShowCouponDiscount() {
        return !isEqual(this.item["fl_coupon_discount"], 0)
      },
      mustShowPromotionDiscount() {
        return !isEqual(this.item["fl_promotion_discount"], 0)
      },
      currencySymbol() {
        if (this.$appMng.isIntl)
          return "$"
        return "R$"
      }
    },
    created() {
      let sendData = {
        "ab_analysis_type": this.item.price_post_processing.agronomic_analyzes.ab_analysis_type,
        "ab_crop_type": this.item.price_post_processing.crop_type.ab_crop_type,
        "cd_field_post_processing": this.item.cd_field_post_processing
      }
      
      getDataPackageHectareCart(this.$apiAuth.getAuthToken(), sendData)
        .then(res => {
          const data = res.data.data
          this.data_package = data

        })
        .catch(() => {
          this.$notify(new NotificationOptions({
            message: "Não foi possível obter os dados do pacote",
            type: NOTIFICATION_TYPES.ERROR
          }))              
        })      
    }
  }
</script>

<style scoped>

</style>
